module.exports = __webpack_public_path__ + "static/media/ambrussum_via.8390ecd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/ambrussum_via.png
// module id = 701
// module chunks = 0